// Auto-generated cornerstone translation for zh.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T15:20:43.433484+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "马匹管理应用：2026年最佳选择 | EquiSight",
      description: "比较适合马主、马厩和育种场的马匹管理应用。了解为什么EquiSight是您管理爱马的完整解决方案。",
      keywords: [
        "马匹管理应用",
        "马厩管理应用",
        "马匹日志应用",
        "多马匹管理应用",
        "母马妊娠管理应用",
        "马匹育种应用",
        "最佳马匹管理应用",
      ],
    },
    hero: {
      eyebrow: "选购指南 · 马匹管理软件",
      breadcrumbLabel: "马匹管理应用",
      title: "马匹管理应用：为马主、马厩和育种场提供的完整选购指南。",
      intro: "这不只是一份功能清单——而是一份公正的比较、一份选购指南，以及对2026年马匹管理应用真正应具备哪些功能的深度解析。无论您只有一匹马、一整个马厩，还是一家育种场，都能找到答案。",
      pills: [
        {
          icon: "Users",
          label: "适合马主",
        },
        {
          icon: "Building2",
          label: "适合马厩",
        },
        {
          icon: "Baby",
          label: "适合育种场",
        },
        {
          icon: "Share2",
          label: "适合团队",
        },
      ],
      ctas: [
        {
          label: "免费从1匹马开始",
          href: "#start",
          primary: true,
        },
        {
          label: "查看对比表",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "为什么马匹管理应用变得越来越重要。",
      lead: "现实中的马匹管理往往极为分散：WhatsApp、日程表、Excel、手机里的照片、纸质护照、零散发票和口头约定。即便只有一匹马，处理起来也颇为不便。一旦涉及多匹马、育种场或共同照护，便很容易出现信息漏洞、错过约定和产生纠纷。",
      items: [
        "那次疫苗接种日期到底是哪天？",
        "谁付了蹄铁师的费用？",
        "今天应该检查哪匹母马？",
        "训练师看过上周的训练指示了吗？",
        "那份照片文件我真的保存了吗？",
        "马厩里贴的饲喂计划还是最新的吗？",
      ],
    },
    what: {
      title: "什么是马匹管理应用？",
      lead: "马匹管理应用本质上是每匹马的数字档案。告别零散的笔记，用一个平台集中管理健康、训练、饲喂、文件、日程、提醒、费用、照片、视频和共享访问权限。马匹周围的每个人都能查看同一份最新信息。",
      targetGroupsTitle: "马匹管理应用适合哪些人？",
      targetGroups: [
        {
          icon: "Heart",
          title: "个人马主",
          body: "一匹马，一份档案——健康记录、日程安排和历史信息触手可及。",
        },
        {
          icon: "Users",
          title: "多马匹马主",
          body: "独立档案、独立日程，为整个团队共享任务清单。",
        },
        {
          icon: "Building2",
          title: "寄养马厩与骑术学校",
          body: "马主访问权限、护理指示、共享日程和任务管理。",
        },
        {
          icon: "Baby",
          title: "育种场",
          body: "母马发情周期、妊娠记录、种公马信息、血统谱系和幼驹发育追踪。",
        },
        {
          icon: "Target",
          title: "训练师",
          body: "查看每匹马的详细信息、记录训练课程、设定目标、分析训练视频。",
        },
        {
          icon: "ClipboardList",
          title: "专业人士",
          body: "蹄铁师、牙科医生、物理治疗师或兽医——基于同一份档案开展工作。",
        },
      ],
    },
    criteria: {
      title: "一款优秀的马匹管理应用应具备哪些条件？",
      lead: "一款好应用不只是界面好看——它必须在日常使用中切实可行。以下五项功能是2026年选购时不可或缺的。",
      items: [
        {
          icon: "FileText",
          title: "每匹马的专属档案",
          body: "基本信息、年龄、品种、护照信息、马主、马厩、照片和文件——全部关联到同一份马匹档案。",
        },
        {
          icon: "Heart",
          title: "健康与护理",
          body: "疫苗接种、驱虫、蹄铁师、牙科、兽医、治疗记录、药物管理，以及到期前的自动提醒。",
        },
        {
          icon: "Activity",
          title: "训练与进展",
          body: "记录训练课程、添加笔记、上传视频、记录比赛成绩，以及按项目或按马匹追踪目标和进展。",
        },
        {
          icon: "Apple",
          title: "饲喂与管理",
          body: "饲喂计划、营养补充剂、粗饲料、体重、体况评分，以及马厩需要了解的日常护理程序。",
        },
        {
          icon: "Share2",
          title: "与他人共享",
          body: "为马主、护理员、训练师、马厩管理员或专业人士提供访问权限——并按各自角色进行权限管理。",
        },
        {
          icon: "Calendar",
          title: "日程与提醒",
          body: "共享日程，包含任务、自动提醒和确认功能，确保万无一失。",
        },
      ],
    },
    comparison: {
      title: "EquiSight与其他马匹管理应用的对比。",
      lead: "目前市场上的同类产品包括Stalmanager、LogMyHorse、EquineM和Happie Horse，各有其优势。我们基于公开信息，对最常被问及的功能进行了公正的并排比较。",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "免费开始使用",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "支持多匹马",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "健康档案",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "训练与进展",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "饲喂与营养补充",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "日程与提醒",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "每马文件管理",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "团队共享与权限管理",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "育种模块（完整版）",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "母马发情周期",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "妊娠计划与超声记录",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "幼驹发育追踪",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "专业人士集成",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach智能洞察",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "适合马主使用",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "适合育种场使用",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "适合马厩/骑术学校使用",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "对比基于2026年1月公开的功能信息。其他竞品也是不错的工具；EquiSight的设计初衷是将所有模块整合在一款应用中。",
    },
    why: {
      title: "EquiSight的与众不同之处。",
      lead: "普通日志只是记录。EquiSight将马匹管理、训练、饲喂、健康、比赛、专业人士和育种功能整合在一款现代应用中——并通过智能洞察更进一步。",
      points: [
        {
          icon: "Heart",
          title: "一款应用，陪伴马匹的整个生命历程",
          body: "从幼驹到运动马、育种母马或退役马，档案随马匹成长而完善——沿途不遗失任何信息。",
        },
        {
          icon: "Sparkles",
          title: "不只是数据，更能发现规律",
          body: "EquiCoach综合分析发育情况、反复出现的健康问题、训练和饲喂数据——让您及时发现信号，而非只是孤立的提示。",
        },
        {
          icon: "Share2",
          title: "专为协作而生",
          body: "马主、马厩管理员、训练师、蹄铁师和其他专业人士基于同一份马匹档案协同工作——每人拥有与其角色相匹配的权限。",
        },
      ],
    },
    nicheA: {
      eyebrow: "细分场景 · 育种场",
      title: "专为育种场设计的马匹管理功能。",
      lead: "许多竞品对育种功能一笔带过。EquiSight打造了完整的育种模块——因为育种师往往不是通用应用的目标用户，但他们对计划管理的需求却比任何人都更为迫切。",
      items: [
        "每日记录母马发情周期",
        "输精日期与种公马信息",
        "妊娠检查与超声记录",
        "预产期与预警提醒",
        "按月追踪幼驹发育",
        "血统谱系与亲本信息",
        "每匹母马的专属备注",
        "所有妊娠母马总览",
      ],
      ctaLabel: "查看育种模块",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "细分场景 · 马厩与骑术学校",
      title: "适用于多匹马和寄养马厩的管理功能。",
      lead: "管理多匹马时，核心不在于数据，而在于沟通。每位马主有各自的需求、日常护理安排、饲喂约定和医疗注意事项。每位员工都应该能够即时获取这些信息，无需四处查找。",
      cards: [
        {
          t: "按马主分配马匹",
          d: "每位马主只能看到自己的马匹。",
        },
        {
          t: "护理指示",
          d: "马厩可查看每匹马的专属护理说明。",
        },
        {
          t: "共享日程",
          d: "蹄铁师、兽医和比赛信息一览无余。",
        },
        {
          t: "任务清单",
          d: "分配给员工，并支持确认功能。",
        },
        {
          t: "马主访问权限",
          d: "客户可在自己的应用中查看爱马信息。",
        },
        {
          t: "紧急联系人",
          d: "马厩紧急情况下随时可查。",
        },
      ],
      ctaLabel: "查看马厩模块",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "从WhatsApp、Excel和白板，迈向EquiSight。",
      lead: "具体来说：您的日常马匹管理将这样改变。",
      rows: [
        {
          before: "WhatsApp群组",
          after: "每匹马的结构化笔记",
        },
        {
          before: "Excel表格",
          after: "带有历史记录的实时马匹档案",
        },
        {
          before: "马厩白板",
          after: "手机上的共享日程",
        },
        {
          before: "相机里的零散照片",
          after: "与马匹档案关联的媒体文件",
        },
        {
          before: "口头约定",
          after: "带确认功能的任务与提醒",
        },
        {
          before: "纸质护照找不到",
          after: "文件随时触手可及",
        },
      ],
    },
    helper: {
      title: "哪款马匹管理应用最适合您？",
      lead: "回答以下5个问题，即可获得公正的推荐建议——即使答案并不总是EquiSight。",
      questions: [
        {
          id: "horses",
          q: "您有一匹马还是多匹马？",
          options: [
            {
              label: "一匹马",
              score: 1,
            },
            {
              label: "2–5匹马",
              score: 2,
            },
            {
              label: "5匹以上",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "您是否管理客户或他人的马匹？",
          options: [
            {
              label: "不，只管理我自己的马",
              score: 0,
            },
            {
              label: "偶尔——为家人或熟人",
              score: 1,
            },
            {
              label: "是，以专业身份（马厩/骑术学校）",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "您是否需要记录育种和妊娠信息？",
          options: [
            {
              label: "不需要",
              score: 0,
            },
            {
              label: "偶尔——临时性育种",
              score: 1,
            },
            {
              label: "是，我是（或将成为）育种师",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "您是否与训练师、护理员或专业人士协作？",
          options: [
            {
              label: "不，我独自处理一切",
              score: 0,
            },
            {
              label: "是，与1人协作",
              score: 1,
            },
            {
              label: "是，与多人协作",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "您只需记录信息，还是也希望获得深度洞察？",
          options: [
            {
              label: "仅记录信息",
              score: 1,
            },
            {
              label: "记录+日程管理",
              score: 2,
            },
            {
              label: "记录+日程管理+深度洞察",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "一款简单的日志应用就够用——而且可随需求成长。",
          body: "对于没有共同护理需求的单马主来说，任何马匹管理应用都能满足基本需求。EquiSight支持免费从1匹马开始使用，零风险。如果您以后想添加更多马匹、引入训练师或开展育种，所有功能都已内置其中。",
          cta: "免费从1匹马开始",
        },
        mid: {
          title: "EquiSight非常适合您的情况。",
          body: "您有多种需求（多匹马、协作或深度洞察）。大多数竞品只覆盖1-2个模块；EquiSight将它们整合在一款应用中，无需连接多个独立工具。",
          cta: "了解EquiSight的功能",
        },
        high: {
          title: "EquiSight是最合逻辑的选择。",
          body: "您的情况涉及多匹马、团队协作、育种管理和/或深度洞察需求。这正是EquiSight脱颖而出的场景——没有分散的工具，只有一份整合了马匹周围所有人和所有事务的完整档案。",
          cta: "免费开始使用EquiSight",
        },
      },
    },
    faqTitle: "关于马匹管理应用的常见问题",
    faq: [
      {
        q: "哪款马匹管理应用最好？",
        a: "最好的马匹管理应用取决于您的具体需求。如果只需要简单的日志功能，多款应用都能胜任。如果您希望将健康、训练、饲喂、文件、育种、日程和协作功能整合在一起，EquiSight正是作为一体化解决方案而打造的——所有内容汇聚于同一份档案。",
      },
      {
        q: "我可以在一款应用中管理多匹马吗？",
        a: "可以。一款优秀的马匹管理应用应支持多匹马，包括为每匹马管理马主信息、护理员、日常程序、文件、约定和提醒。EquiSight从第一行代码起便为此而设计——马匹是独立的个人档案，而非列表中的一行数据。",
      },
      {
        q: "EquiSight也适合育种场使用吗？",
        a: "适合。EquiSight可配置完整的育种功能，包括母马发情周期、输精日期、妊娠检查、种公马信息、血统谱系、预产期和幼驹发育追踪。这正是大多数竞品几乎不涉及的领域。",
      },
      {
        q: "我可以与训练师或蹄铁师共享数据吗？",
        a: "可以。EquiSight的设计目标之一，就是让相关信息能够安全地与马匹周围的人共享——包括训练师、蹄铁师、牙科医生、兽医、物理治疗师、护理员或马主。每个人只获得其角色所需的权限。",
      },
      {
        q: "为什么不直接用WhatsApp或Excel？",
        a: "在事务简单的情况下，WhatsApp和Excel确实可以应付。但一旦涉及多匹马、多个约定、文件、治疗记录、马主或育种数据，就很容易出错：信息四散、查找耗时、口头约定无从追溯。马匹管理应用将所有信息以马匹为单位集中管理，并提供自动提醒。",
      },
      {
        q: "EquiSight的费用是多少？",
        a: "您可以免费从1匹马开始使用。如需管理多匹马、启用育种功能或为专业人士提供访问权限，可选择价格实惠的高级套餐。请访问定价页面查看最新方案。",
      },
    ],
  },
  manege: {
    seo: {
      title: "马术俱乐部管理软件：完整对比与选购指南 2026",
      description: "比较适用于课程、骑手、马匹和行政管理的马术俱乐部软件。探索哪款应用最适合您的马术俱乐部或寄养马厩。",
      keywords: [
        "马术俱乐部管理软件",
        "马厩管理应用",
        "马术俱乐部行政软件",
        "马术课程排班",
        "寄养马厩软件",
        "骑手信息管理",
        "马匹管理系统",
      ],
    },
    hero: {
      eyebrow: "选购指南 · 马术俱乐部软件",
      breadcrumbLabel: "马术俱乐部软件",
      title: "马术俱乐部软件：适用于马术俱乐部与寄养马厩的完整选购指南。",
      intro: "课程排班、骑手信息管理、马匹管理、开票与沟通——一款优秀的马术俱乐部软件将这一切整合在一起。比较最知名的选项，找出最适合您的马厩或俱乐部的解决方案。",
      pills: [
        {
          icon: "Calendar",
          label: "课程排班",
        },
        {
          icon: "Users",
          label: "骑手与客户",
        },
        {
          icon: "Heart",
          label: "马匹护理",
        },
        {
          icon: "CreditCard",
          label: "开票管理",
        },
      ],
      ctas: [
        {
          label: "申请演示",
          href: "#start",
          primary: true,
        },
        {
          label: "查看对比表",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "为什么分散的工具会拖慢马术俱乐部的运营。",
      lead: "大多数马术俱乐部依靠拼凑的方式运营：课程排班用白板，骑手登记用 Excel，开票用另一个工具，马匹护理靠 WhatsApp，与马主的沟通则通过私信。忙碌的一周容易造成重复预订、遗漏发票，或马匹不清楚分配给哪位骑手。",
      items: [
        "现在谁在上茉莉的课？",
        "哪位骑手还没支付三月份的费用？",
        "本周哪匹马不能上课？",
        "学员的紧急联系人是谁？",
        "Stardust 的马主是否已收到装蹄师的账单？",
        "哪匹马住在哪个马厩？",
      ],
    },
    what: {
      title: "什么是马术俱乐部管理软件？",
      lead: "马术俱乐部管理软件将课程排班、骑手信息管理、马匹管理、开票与沟通整合在一个工具中。无需繁琐的 Excel 操作或混乱的 WhatsApp 群组，只需一个平台，俱乐部在此运营，马主与骑手也可随时查看。",
      targetGroupsTitle: "哪类企业适合使用马术俱乐部管理软件？",
      targetGroups: [
        {
          icon: "Building2",
          title: "小型马术俱乐部（1-15匹马）",
          body: "专注于课程排班和收款——轻松管理，无繁琐行政。",
        },
        {
          icon: "Users",
          title: "中型马术俱乐部（15-40匹马）",
          body: "多位教练、课程排班 + 马匹日程 + 骑手信息管理。",
        },
        {
          icon: "ClipboardList",
          title: "大型骑乘与寄养马厩（40匹以上）",
          body: "全面运营管理，包括开票、饲料及装蹄师排班。",
        },
        {
          icon: "Heart",
          title: "寄养马厩",
          body: "马主门户、个性化护理说明、共享日程。",
        },
        {
          icon: "Target",
          title: "障碍赛训练马厩",
          body: "赛事排班、按马匹制定训练计划、客户沟通。",
        },
        {
          icon: "FileText",
          title: "马术创业者",
          body: "课程 + 寄养 + 诊所 + 交易的混合模式——全部在一个系统中管理。",
        },
      ],
    },
    criteria: {
      title: "优质马术俱乐部软件需满足哪些条件？",
      lead: "界面漂亮的应用毫无意义，如果员工不愿意使用的话。以下五个实用标准决定成功与挫败之间的差距。",
      items: [
        {
          icon: "Calendar",
          title: "多层次课程排班",
          body: "初级/进阶、盛装舞步/障碍赛、马匹匹配及教练日程——全部一目了然。",
        },
        {
          icon: "Users",
          title: "骑手信息管理",
          body: "个人资料、级别、订阅、课时卡及青少年骑手的家庭成员关联。",
        },
        {
          icon: "Heart",
          title: "马匹排班",
          body: "记录每匹马的使用频率，以及休息期、受伤期和恢复期。",
        },
        {
          icon: "CreditCard",
          title: "开票与订阅管理",
          body: "月度订阅、课时卡、单次课程及自动扣款。",
        },
        {
          icon: "Share2",
          title: "马主门户（寄养马厩）",
          body: "马主可在专属应用中查看自己马匹的日程、费用、装蹄师记录和备注，无需来电咨询。",
        },
        {
          icon: "Bell",
          title: "沟通与提醒",
          body: "自动课程提醒、付款通知、装蹄师公告——无需手动发消息。",
        },
      ],
    },
    comparison: {
      title: "EquiSight 与其他马术俱乐部软件对比。",
      lead: "许多马术俱乐部工具在课程排班或开票方面表现出色，但很少能同时兼顾马匹护理和马主沟通。我们将它们进行客观横向比较。",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "免费开始 / 试用期",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "课程排班",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "多位教练",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "骑手信息管理",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "马匹排班",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "马匹护理（疫苗/装蹄师）",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "课时卡 / 订阅管理",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "在线支付",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "自动开票",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "马主门户（寄养）",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "装蹄师/兽医整合",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/短信提醒",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "移动端（iOS/Android）",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "赛事排班",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "适用于寄养马厩",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "对比基于2026年1月公开可查的功能信息。Stalmanager 在行政管理方面表现突出，EquiSight 在寄养马厩流程、马匹护理及马主门户方面具有明显优势。",
    },
    why: {
      title: "EquiSight 为何在马术俱乐部和寄养马厩中与众不同。",
      lead: "EquiSight 不仅仅是一个课程排班工具。我们将马术俱乐部视为完整的运营体系：马匹、人员、沟通与财务——彼此相互依存。",
      points: [
        {
          icon: "Heart",
          title: "以马匹为核心，而非日程",
          body: "每匹马都有独立档案。课程记录、健康状况、装蹄师和赛事信息汇聚在一条时间轴上——而非分散在3个独立工具中。",
        },
        {
          icon: "Share2",
          title: "马主随时查看，无需电话",
          body: "寄养马厩的马主拥有专属视图：费用、排班、照片和备注——每周节省5至10个电话沟通。",
        },
        {
          icon: "Bell",
          title: "自动化沟通",
          body: "课程提醒、疫苗提醒、发票——全部自动发送，通过应用/邮件/短信。不再需要群发 WhatsApp 消息。",
        },
      ],
    },
    nicheB: {
      eyebrow: "专为寄养马厩设计",
      title: "EquiSight 为寄养马厩提供的功能。",
      lead: "寄养马厩面临的独特挑战，是普通马术俱乐部软件无法解决的。",
      cards: [
        {
          t: "马主门户",
          d: "每位马主只能查看自己的马匹、日程和费用。",
        },
        {
          t: "按马匹定制护理说明",
          d: "饲料、粗饲料、营养补充剂、马衣排班——马厩工作人员随时可查。",
        },
        {
          t: "共享日程",
          d: "装蹄师、兽医和马主来访信息集中在一个视图中。",
        },
        {
          t: "按马匹计算消耗成本",
          d: "垫料、饲料、精饲料费用按马主分摊计算。",
        },
        {
          t: "马匹紧急联系人",
          d: "马主、兽医和装蹄师的联系方式，马厩随时可查。",
        },
        {
          t: "牧场管理",
          d: "记录哪些马正在放牧、休息或康复中。",
        },
      ],
    },
    beforeAfter: {
      title: "从白板 + Excel 到 EquiSight。",
      lead: "具体来说：马术俱乐部工作周的变化。",
      rows: [
        {
          before: "白板记录课程排班",
          after: "按教练实时查看排班",
        },
        {
          before: "Excel 记录骑手与课程备注",
          after: "带课程历史的客户 CRM",
        },
        {
          before: "WhatsApp 联系马主",
          after: "马主专属门户查看马匹信息",
        },
        {
          before: "每月手动扣款",
          after: "自动开票 + iDEAL 支付",
        },
        {
          before: "马匹护理记录在纸质公告板上",
          after: "按马匹共享护理说明",
        },
        {
          before: "口头约定装蹄师时间",
          after: "装蹄师排班附确认通知",
        },
      ],
    },
    helper: {
      title: "哪款马术俱乐部软件适合您？",
      lead: "5个问题，帮助您判断 EquiSight 是否是您的马术俱乐部或寄养马厩的合适平台。",
      questions: [
        {
          id: "size",
          q: "您的业务中有多少匹马？",
          options: [
            {
              label: "少于10匹",
              score: 1,
            },
            {
              label: "10-30匹",
              score: 2,
            },
            {
              label: "超过30匹",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "您的主要业务是什么？",
          options: [
            {
              label: "主要提供骑乘课程",
              score: 1,
            },
            {
              label: "寄养马厩（马匹寄养）",
              score: 3,
            },
            {
              label: "课程与寄养混合模式",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "您有多少位教练？",
          options: [
            {
              label: "只有我自己",
              score: 1,
            },
            {
              label: "2-3位教练",
              score: 2,
            },
            {
              label: "4位或以上",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "您目前如何处理开票？",
          options: [
            {
              label: "手动处理（Word/Excel）",
              score: 3,
            },
            {
              label: "使用独立的会计软件",
              score: 2,
            },
            {
              label: "已集成在课程工具中",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "您如何与马主沟通？",
          options: [
            {
              label: "当面沟通 / WhatsApp",
              score: 3,
            },
            {
              label: "邮件 + WhatsApp",
              score: 2,
            },
            {
              label: "工具内的马主门户",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "目前轻量工具或 Excel 尚可应付——但 EquiSight 可随您一起成长。",
          body: "对于只有一位教练且寄养业务较少的小型课程俱乐部，暂时不需要功能全面的系统。EquiSight 免费起步，随您的俱乐部发展而扩展——几年后无需经历痛苦的数据迁移。",
          cta: "免费开始",
        },
        mid: {
          title: "EquiSight 是您马术俱乐部的自然升级选择。",
          body: "多位教练、课程与寄养混合模式，或目前独立运行的开票系统——EquiSight 将这一切整合为一套工作流程。尤其是马主门户，可大幅减少临时性沟通需求。",
          cta: "申请演示",
        },
        high: {
          title: "EquiSight 专为您的规模而生。",
          body: "寄养马厩 + 课程 + 多位教练，正是 EquiSight 区别于传统马术俱乐部工具的优势所在。马主门户和马匹护理整合每周可节省大量行政与沟通时间。",
          cta: "为您的马厩预约演示",
        },
      },
    },
    faqTitle: "关于马术俱乐部管理软件的常见问题",
    faq: [
      {
        q: "哪款马术俱乐部管理软件最好？",
        a: "对于纯课程排班需求，市面上有多个不错的选择。一旦您需要管理寄养马厩、多位教练或马匹护理追踪，EquiSight 便成为最完整的解决方案——无需在多个工具间切换，一切尽在一处。",
      },
      {
        q: "我可以导入现有客户和课程数据吗？",
        a: "可以。客户信息和课程安排可通过 CSV 文件导入。我们还会为在运营中的马术俱乐部提供一次性数据迁移协助，让您无需手动输入200位骑手的信息。",
      },
      {
        q: "它也适用于没有课程的纯寄养马厩吗？",
        a: "适用。寄养马厩模式可关闭课程功能，专注于马主门户、饲料/护理管理、装蹄师排班及按马匹分摊费用。",
      },
      {
        q: "骑手可以自行报名和付款吗？",
        a: "可以。骑手可通过个人账户查看开放的课程，自行报名，使用 iDEAL 支付学费，以及购买课时卡。",
      },
      {
        q: "马匹和马主数据的隐私如何保障？",
        a: "每位用户均有指定角色（马主、骑手、教练、员工）。每种角色只能查看其所需的信息。马主只能看到自己的马匹，骑手只能查看自己的课程。",
      },
      {
        q: "EquiSight 可以与我的会计软件对接吗？",
        a: "可以，支持与 Exact、Moneybird 和 e-Boekhouden 对接。发票将自动同步至您的会计系统。",
      },
    ],
  },
  trainer: {
    seo: {
      title: "马术教练应用对比与选型指南（2026年）",
      description: "对比马术教练应用：训练日志、视频、目标、规程分析与客户管理。为教练找到合适的工具。",
      keywords: [
        "马术教练应用",
        "骑马教练软件",
        "马匹训练应用",
        "骑手辅导应用",
        "马术训练日记",
        "盛装舞步规程分析",
        "马术教练管理软件",
      ],
    },
    hero: {
      eyebrow: "选型指南 · 教练软件",
      breadcrumbLabel: "教练应用",
      title: "马术教练应用：面向教练的完整选型指南。",
      intro: "教练或指导员需要同时管理学员组合、课程、视频、目标和比赛。对比最适合马术从业者的教练应用，选择一个2026年依然能与你的业务共同成长的平台。",
      pills: [
        {
          icon: "Target",
          label: "目标与计划",
        },
        {
          icon: "Video",
          label: "视频分析",
        },
        {
          icon: "TrendingUp",
          label: "进度追踪",
        },
        {
          icon: "Users",
          label: "客户/学员组合",
        },
      ],
      ctas: [
        {
          label: "免费注册为教练",
          href: "#start",
          primary: true,
        },
        {
          label: "查看对比表",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "为什么靠WhatsApp执教会限制你的发展。",
      lead: "大多数教练使用零散工具：WhatsApp沟通、笔记本记课、YouTube或WeTransfer传视频、Excel记比赛成绩。学员不超过5人时还能应付，但当学员达到20人时，信息开始丢失，目标被遗忘，对每位学员的个人进步也失去把握。",
      items: [
        "今年赛季Anouk的目标是什么？",
        "上个月我发给Bram的是哪段视频？",
        "Lara看过她上次比赛的规程分析了吗？",
        "每个学员组合每周训练几次？",
        "Stardust的马主读过我的训练说明了吗？",
        "上次我对冲力波动给出反馈是什么时候？",
      ],
    },
    what: {
      title: "什么是马术骑手教练应用？",
      lead: "教练应用集成了辅导CRM（学员组合、课程、目标）、每匹马的训练日志、视频反馈、比赛规划和规程分析。告别零散的WhatsApp/YouTube/Excel，统一在一个平台上让教练与骑手协同工作。",
      targetGroupsTitle: "适合哪种类型的教练？",
      targetGroups: [
        {
          icon: "Target",
          title: "盛装舞步指导员",
          body: "扫描规程、将裁判评语与训练目标挂钩、直观呈现进步。",
        },
        {
          icon: "Activity",
          title: "障碍跳跃教练",
          body: "路线规划、单轮反馈、按马匹管理障碍高度。",
        },
        {
          icon: "Award",
          title: "三项赛教练",
          body: "三个项目、三套计划——全部并排呈现。",
        },
        {
          icon: "TrendingUp",
          title: "竞技表现教练",
          body: "EPI追踪、赛事管理、目标设定——服务于精英骑手及其团队。",
        },
        {
          icon: "Users",
          title: "马场指导员",
          body: "团体课与个人辅导在同一应用中管理。",
        },
        {
          icon: "Heart",
          title: "休闲骑乘教练",
          body: "马术治疗、初学者辅导、只有一匹马的马主。",
        },
      ],
    },
    criteria: {
      title: "一款优秀的教练应用应具备哪些条件？",
      lead: "执教是一门人的艺术，但合适的工具能让你的效率提升30-50%，并帮助骑手在课后持续进步。",
      items: [
        {
          icon: "Users",
          title: "学员组合管理",
          body: "马与骑手作为一个整体单元，包含级别、目标、进度与历史记录。",
        },
        {
          icon: "ClipboardList",
          title: "课程笔记与目标",
          body: "每节课记录重点，并与长期目标相关联。",
        },
        {
          icon: "Video",
          title: "视频反馈",
          body: "上传视频、标记时间点、添加语音或文字反馈。",
        },
        {
          icon: "Target",
          title: "比赛与规程分析",
          body: "扫描规程（KNHS/FEI），按项目查看得分、裁判评语及趋势。",
        },
        {
          icon: "Calendar",
          title: "排课与课时卡",
          body: "日程管理、付款、订阅及自动提醒。",
        },
        {
          icon: "Share2",
          title: "向骑手传递信息",
          body: "骑手可查看自己的专属页面，包括课程、视频、目标和反馈。",
        },
      ],
    },
    comparison: {
      title: "EquiSight与其他教练应用对比。",
      lead: "部分教练工具专注于替代WhatsApp，另一些则侧重规程分析。EquiSight将两者结合，并配备完整的马匹档案——让骑手在课后也能持续进步。",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "免费开始使用",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "学员组合管理",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "课程笔记与反馈",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "长期目标设定",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "视频上传与反馈",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "KNHS/FEI规程扫描",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI（表现指数）",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "赛事日历",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "骑手门户",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "课时卡/订阅",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "在线支付",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "集成马匹档案",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "蹄铁师/兽医信息可见",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "适用于教练与骑手",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "单骑手多匹马",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "对比基于2026年1月公开可查的功能信息。EquiSight在规程分析与EPI方面独树一帜，并将其与全面的马匹管理功能融为一体。",
    },
    why: {
      title: "为什么EquiSight提供与众不同的教练体验。",
      lead: "大多数教练工具在课程结束时就停止了。EquiSight则持续延伸——贯穿马匹档案、比赛分析，以及与兽医和马主的协同合作。",
      points: [
        {
          icon: "TrendingUp",
          title: "规程扫描 → 训练目标",
          body: "扫描KNHS规程，立即看到哪些项目需要关注。目标自动浮现。",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach增强你的洞察力",
          body: "来自多节课程、多场比赛和多份规程的数据，揭示你脑海中难以掌握的规律。",
        },
        {
          icon: "Share2",
          title: "与马匹信息深度集成",
          body: "教练可查看马匹的疫苗接种、蹄铁师和伤病历史——避免在恢复期安排训练。",
        },
      ],
    },
    nicheA: {
      eyebrow: "适用于盛装舞步与障碍跳跃",
      title: "EquiSight辅导档案包含哪些内容。",
      lead: "每个学员组合都有一条辅导记录流，将所有信息汇聚在一起——再也不会在WhatsApp里丢失重要内容。",
      items: [
        "每节课的重点课程笔记",
        "长期目标与里程碑",
        "带时间轴评论的视频上传",
        "含得分的KNHS/FEI规程扫描",
        "与训练挂钩的裁判评语",
        "比赛成绩与EPI趋势",
        "客户联系方式与课程历史",
        "课时卡/订阅/发票",
        "按项目呈现的进度图表",
        "与马主共享访问权限",
      ],
      ctaLabel: "查看教练模块",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "从WhatsApp + YouTube到EquiSight教练平台。",
      lead: "具体而言：你的辅导工作流程将发生这些变化。",
      rows: [
        {
          before: "WhatsApp发送零散视频链接",
          after: "带时间轴反馈的视频存入档案",
        },
        {
          before: "每位骑手一本笔记本",
          after: "含目标与历史记录的辅导日志",
        },
        {
          before: "Excel记录比赛得分",
          after: "EPI图表与规程分析",
        },
        {
          before: "口头约定目标",
          after: "带进度指示器的里程碑",
        },
        {
          before: "单独的开票工具",
          after: "课程+iDEAL+订阅在应用内一体管理",
        },
        {
          before: "发邮件给马主汇报进展",
          after: "马主在专属视图中自主跟进",
        },
      ],
    },
    helper: {
      title: "哪款教练应用适合你？",
      lead: "通过5个问题，了解专业辅导工具是否能为你的业务带来附加价值。",
      questions: [
        {
          id: "clients",
          q: "你目前辅导多少个活跃学员组合？",
          options: [
            {
              label: "少于5个",
              score: 1,
            },
            {
              label: "5-15个",
              score: 2,
            },
            {
              label: "超过15个",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "你的主要专项是什么？",
          options: [
            {
              label: "盛装舞步",
              score: 3,
            },
            {
              label: "障碍跳跃",
              score: 2,
            },
            {
              label: "休闲/综合",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "你在辅导中使用视频吗？",
          options: [
            {
              label: "很少",
              score: 0,
            },
            {
              label: "偶尔（手动处理）",
              score: 2,
            },
            {
              label: "经常——形成系统",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "你辅导参加比赛的骑手吗？",
          options: [
            {
              label: "不，以休闲为主",
              score: 0,
            },
            {
              label: "偶尔参赛",
              score: 2,
            },
            {
              label: "频繁——赛事是核心",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "你希望量化你的辅导成效吗？",
          options: [
            {
              label: "不，凭直觉就够了",
              score: 0,
            },
            {
              label: "想，但没有时间",
              score: 2,
            },
            {
              label: "是的——数据驱动辅导",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "目前一款简单工具甚至WhatsApp就足够了。",
          body: "对于不足5名骑手、视频和比赛需求不多的情况，教练应用属于过度配置。EquiSight免费开始，等你的业务成长时随时可以尝试。",
          cta: "免费开始",
        },
        mid: {
          title: "EquiSight教练版将系统性地提升你的效率。",
          body: "当你拥有5-15个学员组合时，每个月都会在WhatsApp和零散视频上浪费大量时间。EquiSight将所有内容整合在一起，自动扫描规程，并确保骑手随时可以回顾自己的反馈。",
          cta: "试用教练模块",
        },
        high: {
          title: "EquiSight专为你的教练规模而生。",
          body: "大量骑手、视频、赛事和数据驱动辅导——这正是EquiSight的核心优势所在。EPI + 规程扫描 + 马匹档案，为你建立竞争对手无法复制的领先优势。",
          cta: "为你的教练业务预约演示",
        },
      },
    },
    faqTitle: "关于教练应用的常见问题",
    faq: [
      {
        q: "哪款马术骑手教练应用最好？",
        a: "对于单纯的沟通需求，许多工具（甚至WhatsApp）都能胜任。但如果需要在一个工具中同时管理目标、视频分析、规程扫描、赛事追踪和客户管理，EquiSight是最全面的解决方案——尤其是因为它同时追踪马匹本身，而不仅仅是骑手组合。",
      },
      {
        q: "EquiSight能自动读取比赛规程吗？",
        a: "可以。上传KNHS或FEI规程后，EquiSight会自动提取每个项目的得分和裁判评语，并将其关联到对应的学员组合。你可以查看跨多场比赛的趋势变化。",
      },
      {
        q: "什么是EPI（马术表现指数）？",
        a: "EPI是EquiSight的一项评分机制，将多场比赛成绩转化为可比较的表现指数。这样你就能穿越不同级别和不同裁判的差异，看到真实的进步轨迹。",
      },
      {
        q: "骑手可以自己预约课程并付款吗？",
        a: "可以。骑手登录后可查看可用课时、购买课时卡，并通过iDEAL付款。你可以自主决定开放哪些服务。",
      },
      {
        q: "对于在马场工作的指导员也适用吗？",
        a: "适用。你可以作为自由职业教练、拥有自己的客户独立使用，无需关联马场账户。客户直接向你付款。",
      },
      {
        q: "我可以迁移现有的视频和笔记吗？",
        a: "视频可以按学员组合逐一上传，或使用批量上传工具。笔记支持通过CSV导入。我们会为活跃教练提供一次性迁移协助。",
      },
    ],
  },
  ui: {
    sectionEyebrows: {
      pains: "为什么这让人头疼",
      basics: "基础功能",
      criteria: "什么才是好的？",
      comparison: "公正对比",
      why: "与众不同之处",
      beforeAfter: "从零散到全局掌控",
      helper: "5个问题",
    },
    table: {
      feature: "功能",
      today: "现状",
      withEquisight: "使用EquiSight后",
    },
    helper: {
      questionLabel: "第{{current}}题，共{{total}}题",
      answerPrompt: "回答剩余的{{count}}个问题以查看推荐结果。",
      answerPromptPlural: "回答剩余的{{count}}个问题以查看推荐结果。",
      resultEyebrow: "您的结果",
    },
    targetGroupsFallback: "适合哪些用户？",
    faqTitleFallback: "常见问题",
  },
  fokkerij: {
    seo: {
      title: "Fokkerij software paard: complete vergelijking 2026",
      description: "Vergelijk fokkerij software voor paarden: merriecyclus, dracht, hengstkeuze en veulens. Ontdek waarom EquiSight de complete fokkerij app is.",
      keywords: [
        "fokkerij software paard",
        "merriecyclus app",
        "merrie drachtigheid app",
        "veulen registratie app",
        "stamboek app paard",
        "dekplanning paard",
        "hengstkeuze app",
      ],
    },
    hero: {
      eyebrow: "Keuzehulp · fokkerij software",
      breadcrumbLabel: "Fokkerij software",
      title: "Fokkerij software voor paarden: de complete vergelijking voor 2026.",
      intro: "Een fokmerrie verdient meer dan een algemene paardenbeheer app. Vergelijk de fokkerij-functies van de bekendste tools, ontdek waarop je écht moet letten, en kies bewust voor de software die past bij jouw stoeterij — groot of klein.",
      pills: [
        {
          icon: "Baby",
          label: "Merrie cyclus",
        },
        {
          icon: "Heart",
          label: "Drachtcontrole",
        },
        {
          icon: "Sparkles",
          label: "Veulenontwikkeling",
        },
        {
          icon: "FileText",
          label: "Stamboek",
        },
      ],
      ctas: [
        {
          label: "Start gratis met de fokkerijmodule",
          href: "#start",
          primary: true,
        },
        {
          label: "Naar vergelijkingstabel",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Waarom een gewone paardenbeheer app niet volstaat voor fokkerij.",
      lead: "De meeste paardensport apps zijn ontworpen voor één sport- of recreatiepaard. Een fokkerij heeft een hele andere ritmiek: hengstigheid, inseminatie, drachtcontrole, echo's, veulenkalender, stamboom en verkoop. Eén Excel raakt na 2 seizoenen uit het lood — en bij meerdere merries verlies je grip.",
      items: [
        "Wanneer was die laatste cyclus van Bonita ook alweer?",
        "Welke hengst staat gepland voor de dekking volgend seizoen?",
        "Is de 21-daagse echo al ingepland?",
        "Welke veulens van 2024 zijn al verkocht?",
        "Waar staat het stamboomdiagram tot opa van moederszijde?",
        "Waar zijn de DNA-monsters en paspoortgegevens?",
      ],
    },
    what: {
      title: "Wat is fokkerij software voor paarden?",
      lead: "Fokkerij software is een gespecialiseerd dossier per merrie en hengst, gecombineerd met een fokjaar-kalender, drachtplanning, veulenregistratie en stamboomweergave. Geen algemeen paardenlogboek, maar een tool die de fokcyclus begrijpt: van eerste hengstigheid tot afspenen.",
      targetGroupsTitle: "Voor welk type fokker is fokkerij software bedoeld?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobbyfokker (1-3 merries)",
          body: "Eén of twee dekkingen per jaar — overzicht zonder Excel-acrobatiek.",
        },
        {
          icon: "Building2",
          title: "Kleine stoeterij (4-10 merries)",
          body: "Een fokjaarplan met cyclus, inseminatie, drachtcontroles en veulendossier.",
        },
        {
          icon: "Users",
          title: "Professionele stoeterij (10+)",
          body: "Meerdere medewerkers, hengstkeuze per merrie, verkoop en marketing.",
        },
        {
          icon: "Target",
          title: "Hengstenhouder",
          body: "Bestelhistorie, sperma-statistieken en agenda per hengst.",
        },
        {
          icon: "Heart",
          title: "Embryotransplantatie",
          body: "Donor + ontvangermerrie als gekoppeld dossier, ET-kalender.",
        },
        {
          icon: "ClipboardList",
          title: "Stamboek registratie",
          body: "DNA-monsters, paspoortdocumenten en stamboomgegevens.",
        },
      ],
    },
    criteria: {
      title: "Waar moet goede fokkerij software aan voldoen?",
      lead: "Niet elke 'fokkerijfunctie' in een paardenapp is hetzelfde. Vijf kerngebieden waar fokkers veel tijd verliezen — en waar software écht verschil maakt.",
      items: [
        {
          icon: "Calendar",
          title: "Merriecyclus & hengstigheid",
          body: "Dagelijkse log, voorspellende ovulatie, voortrolling per cyclus en automatische herinneringen.",
        },
        {
          icon: "Heart",
          title: "Inseminatie & drachtcontrole",
          body: "Dek- en inseminatiedata, hengstgegevens, 14-daagse echo, 21-daagse echo, 60-daagse echo en geslachtsbepaling.",
        },
        {
          icon: "Baby",
          title: "Veulenontwikkeling",
          body: "Geboorte gegevens, gewichtsgrafiek, ontwormingsschema, speenmoment, paspoortregistratie.",
        },
        {
          icon: "FileText",
          title: "Stamboom & papieren",
          body: "Stamboomweergave tot 4-5 generaties, DNA, paspoortnummers en stamboekstatus.",
        },
        {
          icon: "Target",
          title: "Hengstkeuze & matching",
          body: "Filtreren op discipline, lijnen, hengstgegevens en historisch succes — niet alleen wat een hengsthouder pusht.",
        },
        {
          icon: "Share2",
          title: "Samenwerking dierenarts/inseminator",
          body: "Echo's, monsters en statussen direct gedeeld met de praktijk die werkt aan jouw merries.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs andere fokkerij software.",
      lead: "De Nederlandse SERP voor fokkerij software toont vaak generieke paardenapps die fokkerij in één zin noemen. We vergelijken eerlijk welke tools écht een complete fokkerijflow hebben.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Gratis starten",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Merriecyclus loggen",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Inseminatiedatum + hengst",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Echo's & drachtcontrole",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Verwachte veulendatum",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Veulen dossier (gewicht/groei)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Stamboom tot 4-5 generaties",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA & paspoortregistratie",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Hengstkeuze / matching",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embryotransplantatie",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Multi-merrie overzicht",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobiel (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Delen met dierenarts",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Geïntegreerd met algemeen dossier",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Verkoop & marketing van veulens",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Vergelijking op basis van publiek beschikbare features in januari 2026. EquineGenie is sterk in fokkerij, maar minder in mobiel + algemeen paardenbeheer. EquiSight combineert beide.",
    },
    why: {
      title: "Waarom EquiSight fokkers anders bedient.",
      lead: "Veel fokkers werken met losse fokkerij software én een aparte paardenmanagement app. EquiSight combineert beide — zonder dat je tussen apps switcht of data dubbel invoert.",
      points: [
        {
          icon: "Heart",
          title: "Fokmerrie blijft ook gewoon paard",
          body: "De fokmerrie heeft een fokjaar én een gewoon paardendossier — gezondheid, vaccinaties, hoefsmid. Eén app, alle modules.",
        },
        {
          icon: "Sparkles",
          title: "Voorspellend ipv reactief",
          body: "Cyclusvoorspelling, drachtmijlpaal-herinneringen en veulenkalender — automatisch op basis van jouw data.",
        },
        {
          icon: "Share2",
          title: "Iedereen rondom de fokkerij",
          body: "Inseminator, hengstenhouder, dierenarts, koper, stamboek — allemaal toegang met de juiste rechten.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Per discipline · cyclus tot afspenen",
      title: "Wat een fokkerijdossier in EquiSight bevat.",
      lead: "Per merrie krijg je een compleet fokdossier, gekoppeld aan haar reguliere paarddossier.",
      items: [
        "Dagelijkse cyclus log met voorspelling",
        "Inseminatie/dekking + hengstgegevens",
        "Echo timeline (14/21/60 dagen + geslacht)",
        "Drachtmijlpalen met automatische reminders",
        "Verwachte veulendatum en voorbereiding",
        "Veulen dossier vanaf geboorte",
        "Stamboom tot opa/oma met klik-navigatie",
        "DNA-monster, paspoort, stamboekstatus",
        "Verkoop pipeline met geïnteresseerden",
        "Hengstkeuze geschiedenis per merrie",
      ],
      ctaLabel: "Bekijk de fokkerijmodule",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Voor de hele stoeterij",
      title: "Overzicht voor meerdere merries en hengsten.",
      lead: "Wanneer je meer dan 2-3 merries fokt, wordt overzicht over alle cycli en drachten cruciaal.",
      cards: [
        {
          t: "Cyclus dashboard",
          d: "Alle merries naast elkaar, met cyclusstadium en volgende actie.",
        },
        {
          t: "Dracht pipeline",
          d: "Welke merries zijn waar in de drachtmijlpalen?",
        },
        {
          t: "Veulenkalender",
          d: "Verwachte geboortes per maand, met logistiek erop afgestemd.",
        },
        {
          t: "Hengst portfolio",
          d: "Eigen hengsten of vaste inseminatoren met bestelhistorie.",
        },
        {
          t: "Stamboomgrafiek",
          d: "Voorouder analyse over meerdere generaties en lijnen.",
        },
        {
          t: "Verkoop dashboard",
          d: "Welke veulens zijn verkocht, gereserveerd of nog beschikbaar.",
        },
      ],
    },
    beforeAfter: {
      title: "Van Excel + agenda naar EquiSight fokkerij.",
      lead: "Concreet: zo verandert je fokseizoen.",
      rows: [
        {
          before: "Cyclus in losse notitie",
          after: "Dagelijkse log met voorspelling",
        },
        {
          before: "Echo's via WhatsApp aan inseminator",
          after: "Gedeeld dossier met fotos",
        },
        {
          before: "Drachtdatum in agenda",
          after: "Automatische mijlpaal reminders",
        },
        {
          before: "Veulenpaspoort in la",
          after: "Document gekoppeld aan veulen profiel",
        },
        {
          before: "Stamboom op papier",
          after: "Klikbare stamboom tot 4-5 generaties",
        },
        {
          before: "Verkoopadvertentie op Marktplaats",
          after: "Verkoop pipeline met interesselijst",
        },
      ],
    },
    helper: {
      title: "Welke fokkerij software past bij jou?",
      lead: "5 vragen om te kijken of je een complete fokkerij app nodig hebt of een hobby-tool volstaat.",
      questions: [
        {
          id: "mares",
          q: "Hoeveel fokmerries beheer je?",
          options: [
            {
              label: "1 merrie",
              score: 1,
            },
            {
              label: "2-5 merries",
              score: 2,
            },
            {
              label: "Meer dan 5 merries",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Hoe vaak fok je per jaar?",
          options: [
            {
              label: "Incidenteel (om de paar jaar)",
              score: 0,
            },
            {
              label: "Elk jaar 1-2 dekkingen",
              score: 2,
            },
            {
              label: "Elk jaar 3+ dekkingen",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Hoe insemineer/dek je?",
          options: [
            {
              label: "Natuurlijke dekking",
              score: 1,
            },
            {
              label: "KI vers/gekoeld sperma",
              score: 2,
            },
            {
              label: "ET of diepvries",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Werk je samen met dierenarts/inseminator?",
          options: [
            {
              label: "Eén vaste persoon",
              score: 1,
            },
            {
              label: "Meerdere praktijken",
              score: 2,
            },
            {
              label: "Internationaal netwerk",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Wat houd je nu bij?",
          options: [
            {
              label: "Excel of papier",
              score: 1,
            },
            {
              label: "Algemene paardenbeheer app",
              score: 2,
            },
            {
              label: "Niets gestructureerd",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Een hobby-tool of Excel volstaat — maar EquiSight blijft handig.",
          body: "Voor 1 merrie met natuurlijke dekking om de paar jaar is een uitgebreide fokkerijmodule overkill. EquiSight start gratis en activeer je de fokkerijmodule alleen voor het jaar dat je dekt — zonder upgrade verplichting.",
          cta: "Start gratis",
        },
        mid: {
          title: "EquiSight fokkerij is de juiste tool.",
          body: "Je hebt meerdere merries of meerdere fokmethodes — daar zijn algemene paardenapps niet op gebouwd. EquiSight combineert fokkerij + algemene zorg, zodat je niet tussen twee tools schakelt.",
          cta: "Bekijk de fokkerijmodule",
        },
        high: {
          title: "EquiSight is gebouwd voor jouw stoeterij.",
          body: "Meerdere merries, ET of diepvries, internationaal team — de meeste tools komen hier tekort. EquiSight schaalt mee tot stoeterij-niveau zonder dat je extra licenties stapelt.",
          cta: "Praat met ons over een Stoeterij plan",
        },
      },
    },
    faqTitle: "Veelgestelde vragen over fokkerij software",
    faq: [
      {
        q: "Wat is de beste fokkerij software voor paarden?",
        a: "Voor 1 merrie zonder ingewikkelde fokmethode volstaan veel tools. Vanaf 2-3 merries, gebruik van KI of ET, of samenwerking met dierenarts en stamboek wordt een complete fokkerijmodule cruciaal. EquiSight combineert fokkerij met algemeen paardenbeheer in één app, waardoor je niet hoeft te switchen.",
      },
      {
        q: "Welke fokkerij functies heb ik écht nodig?",
        a: "Minimaal: cyclus log, inseminatie/dekking gegevens, drachtcontrole-mijlpalen, en veulen dossier. Optioneel maar krachtig: stamboomweergave, hengstkeuze archief, DNA/paspoort en verkoop pipeline.",
      },
      {
        q: "Kan EquiSight een merrie's cyclus voorspellen?",
        a: "Ja. EquiSight gebruikt eerdere cyclus-data om de voorspelde ovulatie te tonen, zodat je inseminatie of dekking op het juiste moment plant — zonder dagelijks puzzelen.",
      },
      {
        q: "Werkt EquiSight ook voor embryotransplantatie?",
        a: "Ja. Donor- en ontvangermerrie krijgen gekoppelde dossiers, ET-kalender en gedeelde mijlpalen met de praktijk. Zo verlies je geen tijdlijn in de complexe ET-flow.",
      },
      {
        q: "Kan ik mijn bestaande fokdata importeren?",
        a: "Je kunt cyclus, dekkingen en veulendata handmatig invoeren of in batch via CSV. Bij actieve fokkerijen helpen we met een eenmalige migratie als je over meerdere seizoenen data hebt staan.",
      },
      {
        q: "Hoe deel ik dossier met mijn dierenarts of inseminator?",
        a: "Per persoon krijg je toegang met een rol: dierenarts, inseminator, hengstenhouder of stamboek-functionaris. Iedereen ziet alleen de informatie die nodig is voor zijn rol — geen volledige toegang nodig.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Gidsen & keuzehulpen voor paardenbeheer software | EquiSight",
      description: "Alle EquiSight gidsen op één plek: paardenbeheer, fokkerij, manege en trainer software vergelijkingen plus keuzehulpen voor 2026.",
      keywords: [
        "paardensoftware gidsen",
        "paardenbeheer keuzehulp",
        "fokkerij software vergelijken",
        "manege software gids",
        "trainer app vergelijking",
      ],
    },
    hub: {
      eyebrow: "Hub · gidsen",
      breadcrumbLabel: "Gidsen",
      title: "Vier complete gidsen om de juiste paardensoftware te kiezen.",
      intro: "Voor iedere doelgroep een diepgaande keuzehulp: vergelijkingstabellen, criteria, voorbeelden en interactieve quiz. Klik door naar de gids die past bij jouw situatie, of verken eerst de verdiepende artikelen onder elke cluster.",
      stats: {
        guides: "4 keuzehulpen",
        articles: "15 verdiepende artikelen",
        fair: "Eerlijke vergelijking",
      },
      readMoreCta: "Lees de complete gids",
      relatedHeading: "Verdiepende artikelen",
      articlesCountSingular: "{{count}} verdiepend artikel",
      articlesCountPlural: "{{count}} verdiepende artikelen",
      articlesCountAria: "Aantal cluster-artikelen",
      lastUpdatedPrefix: "Bijgewerkt",
      lastUpdatedAria: "Datum laatste update van deze cluster",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Paardenbeheer app keuzehulp",
        blurb: "Vergelijk de bekendste paardenbeheer apps en ontdek welke past bij eigenaar, stal of fokkerij. Inclusief eerlijke vergelijkingstabel en 5-vragen keuzehulp.",
        audience: "Voor eigenaren, stalhouders en alle paardenmensen die overzicht zoeken.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Fokkerij software vergelijking",
        blurb: "Van merriecyclus tot veulenontwikkeling: bekijk welke fokkerij software echt werkt voor jouw aantal merries, fokmethode en stamboek-eisen.",
        audience: "Voor (hobby)fokkers, stoeterijen en hengstenhouders.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Manege software keuzehulp",
        blurb: "Lesplanning, ruiteradministratie, eigenaarsportaal en facturatie — in één tool. Vergelijk de opties voor maneges en pensionstallen in 2026.",
        audience: "Voor maneges, pensionstallen en rij-bedrijven.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Trainer app keuzehulp",
        blurb: "Coaching-CRM, video-feedback, KNHS-protocol scannen en doelen per combinatie. Welke trainer app past bij jouw coaching praktijk?",
        audience: "Voor instructeurs, trainers en coaches.",
      },
    ],
    closing: {
      eyebrow: "Waarom deze gidsen",
      title: "Eerlijk vergelijken, niet alleen prijzen.",
      body1: "Veel \"vergelijkingspagina's\" zijn verkapte advertenties. Onze gidsen zetten functies, doelgroep en concurrenten naast elkaar zoals een onafhankelijke kennisbron dat zou doen. EquiSight komt natuurlijk naar voren als complete oplossing, maar je leest ook eerlijk waar andere apps sterker zijn.",
      body2: "De verdiepende artikelen onder elke gids beantwoorden de concrete vragen die voortkomen uit de keuze: \"Wanneer eerste echo na inseminatie\", \"Hoe automatiseer ik manege facturatie\", \"Hoe analyseer ik een wedstrijdprotocol\". Geen marketingfluff, wel praktijk.",
    },
    hubName: "EquiSight Gidsen",
  },
};

export default CORNERSTONES;
